import { Component, Prop, Mixins } from 'vue-property-decorator';

@Component
/**
 * Header Props
 */
export default class Props extends Mixins() {
    /**
     * Classes
     */
    @Prop() classes!: string | Array<string>;

    /**
     * Menu
     */
    @Prop({ type: Array }) menu!: Array<{ [k: string]: any }>;

    /**
     * Site Logo
     */
    @Prop({ type: String }) siteLogo!: string;

    /**
     * Site Link
     */
    @Prop({ type: String }) siteLink!: string;

    /**
     * Site Title
     */
    @Prop({ type: String }) siteTitle!: string;

    /**
     * Auth Icon
     */
    @Prop({ type: String, default: 'user' }) authIcon!: string;

    /**
     * Auth Icon
     */
    @Prop({ type: String, default: 'fas' }) authIconPrefix!: string;

    /**
     * Register Text
     */
    @Prop({ type: String }) registerText!: string;

    /**
     * Login Text
     */
    @Prop({ type: String }) loginText!: string;

    /**
     * Register link
     */
    @Prop({ type: Object }) registerLink!: object;

    /**
     * Login link
     */
    @Prop({ type: Object }) loginLink!: object;

    /**
     * Lang list
     */
    @Prop({ type: Object }) langList!: object;

    /**
     * Auth Icon
     */
    @Prop({ type: [String, Number], default: 0 }) cartCount!: string | number;

    /**
     * Search placeholder
     */
    @Prop({ type: String }) searchPlaceholder!: string;

    /**
     * Theme color
     */
    @Prop({ type: String, default: 'primary' }) color!: string;

    /**
     * User Contact Info
     * To show in the sidebar, bottom of the user name
     */
    @Prop({ default: 'mobile' }) userContactToShow!: string;

    /**
     * Wallet Box Info
     * `{
     * `  label: '',
     * `  size: '',
     * `  icon: {
     * `    name: '',
     * `    prefix: '',
     * `    library: '',
     * `  }
     * `  link: {
     * `    name: '',
     * `    params: {},
     * `    query: {},
     * `  }
     * `}
     */
    @Prop() walletChargeButton!: object;

    /**
     * Navigation
     * Used Types: Dashboard
     */
    @Prop() navigation!: Array<object>;

    /**
     * Button text
     */
    @Prop() buttonText!: string;

    /**
     * Button Link
     */
    @Prop({ type: Object }) buttonLink!: object;

    /**
     * Button Color
     */
    @Prop() buttonColor!: string;

    /**
     * Show Product Category
     */
    @Prop({ type: Boolean }) productCategories!: boolean;

    /**
     * Contact info element name
     */
    @Prop({ type: String }) ContactInfo!: string;

    /**
     * Category slug
     */
    @Prop({ type: String }) categorySlug!: string;

    /**
     * Category route name
     */
    @(Prop({ type: String })!) categoryRouteName: string;
}
